import React from 'react'
import AboutHero from '../components/aboutpage/AboutHero'
import Pillars from '../components/aboutpage/Pillars'
import Phylosophy from '../components/aboutpage/Philosophy'

function About() {
  return (
    <>
      <AboutHero/>
      <Pillars/>
      <Phylosophy/>
    </>
  )
}

export default About